var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Form, Icon, List, Popup } from 'semantic-ui-react';
var FieldWithErrorDisplay = /** @class */ (function (_super) {
    __extends(FieldWithErrorDisplay, _super);
    function FieldWithErrorDisplay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.filteredErrorMessages = function (path) {
            if (_this.props.muffleErrors) {
                return [];
            }
            return _this.props.errors.filter(function (e) { return e.path === path; })
                .map(function (e) { return e.msg; });
        };
        _this.showErrors = function () {
            return (_this.props.showErrors === true || _this.props.showErrors == null);
        };
        return _this;
    }
    FieldWithErrorDisplay.prototype.render = function () {
        var _this = this;
        var msgs = this.filteredErrorMessages(this.props.errorPath);
        var shouldShowErrors = this.showErrors() && msgs.length > 0;
        var showInlineErrors = this.props.inlineErrors === true;
        // If the label is a blank string, only display the field when there are errors, otherwise always display
        var isLabelVisible = typeof this.props.labelContent === 'string'
            ? this.props.labelContent.trim() === '' ? shouldShowErrors && !showInlineErrors : true
            : true;
        return React.createElement(Form.Field, { disabled: this.props.disabled, error: shouldShowErrors, required: this.props.required },
            isLabelVisible && React.createElement("label", { htmlFor: this.props.labelFor, style: { whiteSpace: this.props.wrapLabelContent ? 'normal' : 'nowrap' } },
                this.props.labelContent,
                "\u00A0",
                shouldShowErrors && !showInlineErrors && React.createElement(Popup, { trigger: React.createElement(Icon, { color: 'red', name: 'exclamation triangle' }), content: React.createElement(List, { items: msgs }), wide: 'very' })),
            this.props.children,
            showInlineErrors && shouldShowErrors &&
                React.createElement("div", { className: "field-error-messages" }, msgs.map(function (msg, i) { return React.createElement("div", { key: _this.props.errorPath + "-" + i }, msg); })));
    };
    return FieldWithErrorDisplay;
}(React.PureComponent));
export default FieldWithErrorDisplay;
//# sourceMappingURL=FieldWithErrorDisplay.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/FieldWithErrorDisplay.js
// module id = 7
// module chunks = 0